<div class="p-3">
  <div class="d-flex flex-row justify-content-between align-items-start">
    <div class="d-flex flex-row justify-content-start align-items-start">
      <div class="fas fa-play-circle text-dark-blue font-size-48 cursor-pointer" (click)="onAction('viewAndPlay')"></div>
      <div class="ml-3">
        <div class="cursor-pointer" (click)="onAction('view')"><strong>{{submission.request.videoTitle}}</strong></div>
        <a [routerLink]="editRequestPath" class="small">View request</a>
      </div>
    </div>

    <div>
      <div class="badge"
        [class.badge-success]="submission.state === 'new'"
        [class.badge-tertiary]="submission.state !== 'new'">
        {{badgeTitle | titlecase}}
      </div>
    </div>
  </div>

  <hr class="my-3">

  <div [hidden]="!expanded">
    <video controls
      #videoPlayer
      preload="true"
      webkit-playsinline
      [src]="submission.editedUrl || submission.initialUrl"
      [style.max-width]="'100%'"
      [style.max-height]="'400px'"></video>
    <hr class="my-3">
  </div>

  <div class="d-flex flex-row justify-content-start align-items-start">
    <button class="btn btn-outline-tertiary btn-sm mr-1"
            (click)="onAction('view')">
      <span *ngIf="expanded">Close</span>
      <span *ngIf="!expanded">View</span>
    </button>

    <button *ngIf="state.purchaseable || state.awaitingEditing"
            [disabled]="state.awaitingEditing"
            class="btn btn-sm mr-1"
            [class.btn-primary]="visibleForm !== 'accept'"
            [class.btn-outline-primary]="visibleForm === 'accept'"
            (click)="onAction('accept')">Accept</button>

    <button *ngIf="state.purchaseable || state.awaitingEditing"
            [disabled]="state.awaitingEditing"
            class="btn btn-outline-tertiary btn-sm"
            (click)="onAction('requestEdits')">Request edits</button>

    <button *ngIf="state.purchased"
            class="btn btn-outline-tertiary btn-sm mr-1"
            (click)="onAction('copyUrl')">Copy URL</button>

    <button *ngIf="state.purchased"
            class="btn btn-outline-tertiary btn-sm mr-1"
            (click)="onAction('embed')">Embed</button>

    <button *ngIf="state.purchased"
            class="btn btn-outline-tertiary btn-sm mr-1"
            (click)="onAction('download')">Download</button>

    <button *ngIf="state.purchased"
            class="btn btn-outline-tertiary btn-sm"
            (click)="onAction('redeliver')">Redeliver</button>
  </div>

  <!-- Forms -->
  <div *ngIf="visibleForm === 'accept'">
    <hr class="my-4">
    <div class="mt-1 mb-3">
        This video will be sent to you according to your configured <a [routerLink]="deliveryOptionsPath">delivery options</a> and made available under the Purchases tab.
    </div>
    <div>
      <button class="btn btn-primary mr-1" (click)="onAccept()"><span class="mx-3">Accept</span></button>
      <button class="btn btn-outline-tertiary" (click)="onAction('accept')">Cancel</button>
    </div>
  </div>

  <div *ngIf="visibleForm === 'requestEdits'">
    <h5 class="mt-4">How would you like to request edits for this video?</h5>
    <label class="d-block">
      <input type="radio" name="feedback" [(ngModel)]="feedback" value="vimeo" required>
      <strong>Targeted feedback.</strong>
      I'll leave slide specific comments on Vimeo
    </label>
    <label class="d-block">
      <input type="radio" name="feedback" [(ngModel)]="feedback" value="comments" required>
      <strong>General feedback.</strong>
      I just want to leave some quick thoughts
    </label>
    <div *ngIf="feedback === 'vimeo'">
      <hr class="my-3">
      <a class="btn btn-primary mr-1" target="_blank" (click)="onRequestEdits('Requests made on Vimeo')" [href]="submission.vimeoUrl">Request edits on Vimeo</a>
      <button class="btn btn-outline-tertiary" (click)="onAction('requestEdits')">Cancel</button>
    </div>
    <div *ngIf="feedback === 'comments'">
      <textarea class="form-control mb-3 col-12 col-md-8" rows="6" placeholder="Your comments here" [(ngModel)]="comments"></textarea>
      <hr class="my-3">
      <button class="btn btn-primary mr-1" (click)="onRequestEdits(comments)">Request edits</button>
      <button class="btn btn-outline-tertiary" (click)="onAction('requestEdits')">Cancel</button>
    </div>
    <div class="small mt-3">
      <i>Once you click "Request edits" our team will be notified. You will receive your final video within 72 hours.</i>
    </div>
    <div class="small">
      <i>This video will be saved to your HubSpot file manager per your settings in <a [routerLink]="deliveryOptionsPath">delivery options</a></i>
    </div>
  </div>

  <div *ngIf="visibleForm === 'embedCode'" class="p-3 mt-3">
    <div>To embed your video, simply copy and paste this code into your HTML or CMS.</div>
    <textarea class="form-control"><video controls src="{{ submission.editedUrl || submission.initialUrl }}"></video></textarea>
  </div>

</div>
